import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  practiceTimezone: "EST",
  countryCode: "US",
};

const practiceSlice = createSlice({
  name: "practices",
  initialState: initialState,
  reducers: {
    setPracticeTimezone: (state, action) => {
      state.practiceTimezone = action.payload;
    },
    setCountryCode: (state, action) => {
      state.countryCode = action.payload;
    },
  },
});

export const { setPracticeTimezone, setCountryCode } = practiceSlice.actions;

export default practiceSlice.reducer;
